import React,{Component} from 'react';
import Logo from "../../../images/logo-black.png";
import Image from "../../../images/product.png";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import SimpleReactValidator from "simple-react-validator";
import {history} from "../../../shared/configure-store";
import {toast, ToastContainer} from "react-toastify";
import Api from "../../../libraries/api";
import language from "../../../libraries/label-lang";
import { withRouter, Link } from 'react-router-dom';
import Button from "@material-ui/core/Button";
import {SearchInput, Selector} from "../styling";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../../presentational/table-pagination-actions";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { bindActionCreators } from 'redux';
import { RootActions } from '../../../shared/root-action';
import { connect } from 'react-redux';
import { coverName } from '../reservations'


const validator = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});

class ContentDashboard extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,

            errors: [],

            warehouses: [],

            userName: '',
            statusFilter: [],
            statusPast: false,
            classes: [],
            plans: [],

            loadingButton: false,

            showDialog: false,
            idDelete: '',
            currDelete: '',

            orderBy: '',
            sortedBy: '',
            searchBy: '',
            keyword: '',

            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,

            warehouseList: [],
            warehouseSelected: '',
            iForgotOldReact: null
        };
    }

    componentDidMount(){

        document.title = 'Fresh Factory - Dashboard';

        this._loadData();
    };

    _loadData = () => {
        this.setState({ loading: true, });
        const { sortedBy:sortedBy, orderBy:orderBy, searchBy: searchBy, warehouseSelected: warehouseId, currentPage: page, keyword:keyword } = this.state

        const params = new URLSearchParams({
            ...(sortedBy ? { sortedBy } : {}),
            ...(orderBy ? { orderBy } : {}),
            ...(searchBy ? { searchBy } : {}),
            ...(warehouseId ? { warehouseId } : {}),
            ...(page ? { page: Number(page) } : {}),
            ...(keyword ? { keyword } : {}),
        }).toString();

        Api.get(`/reservations?${params}`).then(resp => {
            this.setState({
                rows: resp.data,
                perPage: resp.meta.pagination.per_page,
                currentPage: resp.meta.pagination.current_page,
                currentPageTable: resp.meta.pagination.current_page - 1,
                total: resp.meta.pagination.total,
                loading: false,
            });
        })
            .catch(e => {
                this.showMessage(false, e.message);
                this.setState({ loading: false, })
            });

        Api.get(`/warehouses`).then(resp => {
            this.setState({
                warehouseList: resp.data
            });
        })
            .catch(e => {
                this.showMessage(false, e.message);
                // this.setState({ loading: false, })
            })

    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage: newPage + 1,
            currentPageTable: newPage + 1,
            loading: true,
        }, () => {
            this._loadData()
            // this.__fetchData(true);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            perPage: parseInt(event.target.value, 10),
            currentPage: 1,
            loading: true,
        }, () => {
            this._loadData()
            // this.__fetchData(false);
        });
    };

    __fetchData = () => {
        this._isMounted = true;

        this.setState({
            loading: true,
        });
        let client = process.env.REACT_APP_CLIENT;
        let status = this.state.statusFilter.join();
        let route= '';

        if(this.state.statusFilter.length > 0 ) {
            if(this.state.statusPast) {
                route = '/student/passed-classes?org='+client;
            }else {
                route = '/student/classes?org='+client+'&status='+status;
            }

        }else {
            route = '/student/classes?org='+client;
        }

        Api.get(route).then(resp => {
            if (this._isMounted) {

                if (resp.data) {

                    this.setState({
                        classes: resp.data,
                        loading: false,
                    })

                }

            }
        }).catch(err => {
            this.setState({
                loading: false,
            });

            this.showMessage(false, err.message);
        });
    };

    handleChange (e, prop){

        if(prop === 'warehouse') {
            this.setState({

                warehouseName: e.target.value

            })
        }
        this.setState({

            [prop]: e.target.value

        })

    };

    handleGo  = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    __handleSearchEvent = (data,props)=>{
        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        this.setState({
            [props]:data ? data : ''
        },()=> {

            let message = '';
            if (props == 'searchBy' || props == 'keyword') {
                if ((data == 'nota' || data == 'status' || data != '') && this.state.keyword && this.state.searchBy) {
                } else {
                    if((this.state.searchBy == '' || this.state.searchBy == null) && (this.state.keyword == '' || this.state.keyword == null)){
                    }
                    else if ((this.state.searchBy == '' || this.state.searchBy == null) && (this.state.keyword != '' || this.state.keyword != null)) {
                        message = text.label_sortBy;
                    }
                    else if((this.state.searchBy != '' || this.state.searchBy != null) && (this.state.keyword == '' || this.state.keyword == null)) {
                        message = text.label_browse + ' ' + text.label_reservation;
                    }
                    else{
                    }
                }
            }

            if (message) {
                this.showMessage(false, message + ' tidak boleh kosong!');
            }
            else {
                if(props == 'warehouseSelected'){
                    this.setState({
                        searchBy: '',
                        keyword:''
                    },()=>{
                        // this.handleChange(this,'keyword');
                        this._loadData();
                    })
                } //'FNC-TE-TGR20200901-42547')
                else{
                    this._loadData();
                }
            }
        });
    };

    render() {
        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        const dataList = this.state.rows && this.state.rows.length ? true : false;

        return (
            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        {/*<li className='breadcrumb-item active' aria-current='page'>{text.label_reservation}</li>*/}
                    </ol>
                </nav>
                <h2 className='text-uppercase'>{text.label_dashboard}
                    {/*<Button*/}
                    {/*    variant='contained'*/}
                    {/*    color='primary'*/}
                    {/*    className='float-right mb-3'*/}
                    {/*    onClick={() => this.handleGo('/reservations/add')}*/}
                    {/*>*/}
                    {/*    {text.button_add} {text.label_reservation}*/}
                    {/*</Button>*/}
                </h2>

                <div className='d-inline-flex align-items-center w-100 justify-content-between my-2'>

                    <Selector
                        vertical
                        className="w-100"
                        title={text.label_warehouses}
                        // selected={x => this.setState({ warehouseSelected: x }, _ => {
                        //     this._loadData()
                        // })}
                        selected={(x) => this.__handleSearchEvent(x, 'warehouseSelected')}
                        item={this.state.warehouseList}
                    />

                        <div className='d-inline-flex align-items-center justify-content-between'>
                            <Selector
                                vertical
                                className="w-100 mr-2"
                                title={text.label_sortBy}
                                value={this.state.searchBy}
                                selected={(x) => this.__handleSearchEvent(x, 'searchBy')}
                                item={[
                                    {
                                        name: 'Surat Jalan',
                                        id: 'nota'
                                    },
                                    {
                                        name: 'Status',
                                        id: 'status'
                                    },
                                ]}
                            />

                            <SearchInput
                                placeholder={text.label_browse + ' ' + text.label_reservation}
                                value={this.state.keyword}
                                onSubmit={(x) => this.__handleSearchEvent(x, 'keyword')}
                                onKeyPress={(x) => this.__handleSearchEvent(x, 'keyword')}
                                onKeyUp={(x) => this.__handleSearchEvent(x, 'keyword')}
                            />
                        </div>
                    </div>

                <div className='clearfix'> </div>

                <div className='table-wrapper'>
                    <Table className='table-list' size='small' >
                        <TableHead>
                            <TableRow>
                                <TableCell className='clickable' onClick={() => this.handleSort('nota')} >{text.label_reservation_code}
                                    {this.state.orderBy === 'nota' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                <i className='fas fa-sort-down'> </i>
                                            )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('warehouses:warehouse_id|warehouses.name')} >{text.label_warehouses}
                                    {this.state.orderBy === 'warehouses:warehouse_id|warehouses.name' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                <i className='fas fa-sort-down'> </i>
                                            )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('reservationDate')}>{text.label_reservation_date}
                                    {this.state.orderBy === 'reservationDate' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                <i className='fas fa-sort-down'> </i>
                                            )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('productsTotal')}>Jenis Produk (SKU)
                                    {this.state.orderBy === 'productsTotal' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                <i className='fas fa-sort-down'> </i>
                                            )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('productsTotal')}>{text.label_quantity} {text.label_products} (IKU)
                                    {this.state.orderBy === 'productsTotal' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                <i className='fas fa-sort-down'> </i>
                                            )
                                        }</span>
                                    )}
                                </TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('status')}>{text.label_status}
                                    {this.state.orderBy === 'status' && (
                                        <span className='icon-sort'>{
                                            this.state.sortedBy === 'asc' ? (
                                                <i className='fas fa-sort-up'> </i>
                                            ) : (
                                                <i className='fas fa-sort-down'> </i>
                                            )
                                        }</span>
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.loading ? (
                                <TableRow>
                                    <TableCell colSpan={6} align='center' className='py-5'>
                                        <CircularProgress color='primary' />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                this.state.rows.length === 0 ? (
                                    <TableRow style={{ height: 33 * this.state.perPage }}>
                                        <TableCell colSpan={6} style={{ textAlign: 'center' }}>{text.label_no}</TableCell>
                                    </TableRow>
                                ) : (
                                    this.state.rows.map((row, i) => (
                                        <TableRow
                                            key={i}
                                            style={{ cursor: 'pointer' }}
                                            onClick={_ => {
                                                history.push({
                                                    pathname: 'reservations/detail/' + row.id,
                                                    state: row
                                                })
                                            }}
                                            key={row.id}
                                            selected={row.selected}>
                                            <TableCell>{row.nota ? row.nota : '-'}</TableCell>
                                            <TableCell>{row.warehouse && row.warehouse.name ? row.warehouse.name : '-'}</TableCell>
                                            <TableCell>{row.reservationDate ? moment(row.reservationDate).format('DD MMM YYYY') : '-'}</TableCell>
                                            <TableCell>{row.SKUTotal ? row.SKUTotal : 0}</TableCell>
                                            <TableCell>{row.productsTotal ? row.productsTotal : 0}</TableCell>
                                            <TableCell>{row.status ? coverName(row.status, 'indo') : '-'}</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    ))
                                )
                            )}

                        </TableBody>
                    </Table>
                </div>

                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component='div'
                    className='responsive'
                    count={this.state.total}
                    rowsPerPage={this.state.perPage}
                    page={this.state.currentPageTable}
                    backIconButtonProps={{
                        'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'next page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>DELETE PROJECT: {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>{text.text_delete}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleClose}
                        >
                            {text.button_cancel}
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleDelete}
                            disabled={this.state.loadingButton && 'disabled'}
                        >
                            {text.button_delete}{this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i>}
                        </Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer />
            </div>
        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContentDashboard));

